import React from 'react';
import { Box, Typography } from '@mui/material';
import {
	OrderHistoryTrackOrderStepsBarFrameSX,
	OrderHistoryTrackOrderStepsBarSX,
	OrderHistoryTrackOrderStepsFrameSX,
	OrderHistoryTrackOrderStepsLabelsSX,
	OrderHistoryTrackOrderStepsLabelSX,
	OrderHistoryTrackOrderStepsSingleLabelSX,
} from '@/components/content/OrderHistoryDetails/styles/steps';
import { TRACK_ORDER_STATUS } from '@/components/content/OrderHistoryDetails/parts/TrackOrder';

interface OrderHistoryTrackOrderStepsProps {
	orderTrackStatus: TRACK_ORDER_STATUS;
	mobile: boolean;
}

const stepsCommon = ['CONFIRMED', 'IN_PREPARATION', 'ON_THE_WAY', 'DELIVERED'];

const getTrackOrderStepByStatus = (status: TRACK_ORDER_STATUS) => {
	switch (status) {
		case TRACK_ORDER_STATUS.CONFIRMED:
			return 0;
		case TRACK_ORDER_STATUS.IN_PREPARATION:
			return 1;
		case TRACK_ORDER_STATUS.ON_THE_WAY:
			return 2;
		case TRACK_ORDER_STATUS.DELIVERED:
			return 3;
		default:
			return -1;
	}
};

export const getTrackOrderTextByStatus = (step: string) => {
	switch (step) {
		case TRACK_ORDER_STATUS.CONFIRMED:
			return 'Pedido confirmado';
		case TRACK_ORDER_STATUS.IN_PREPARATION:
			return 'Pedido en preparación';
		case TRACK_ORDER_STATUS.ON_THE_WAY:
			return 'Pedido en camino';
		case TRACK_ORDER_STATUS.DELIVERED:
			return 'Pedido entregado';
		case TRACK_ORDER_STATUS.CANCELLED:
			return 'Pedido cancelado';
		default:
			return 'Pedido sin confirmar';
	}
};

export const OrderHistoryTrackOrderSteps: React.FC<OrderHistoryTrackOrderStepsProps> = ({
	orderTrackStatus,
	mobile,
}) => {
	const currentStep = getTrackOrderStepByStatus(orderTrackStatus);

	return (
		<Box sx={OrderHistoryTrackOrderStepsFrameSX}>
			<Box sx={OrderHistoryTrackOrderStepsLabelsSX}>
				{mobile ? (
					<Typography sx={OrderHistoryTrackOrderStepsSingleLabelSX(orderTrackStatus)}>
						{getTrackOrderTextByStatus(orderTrackStatus)}
					</Typography>
				) : (
					<React.Fragment>
						{stepsCommon.map((step, index) => (
							<Typography
								key={step}
								sx={OrderHistoryTrackOrderStepsLabelSX(
									index,
									currentStep,
									stepsCommon.length,
									orderTrackStatus
								)}
							>
								{getTrackOrderTextByStatus(step)}
							</Typography>
						))}
					</React.Fragment>
				)}
			</Box>
			<Box sx={OrderHistoryTrackOrderStepsBarFrameSX}>
				<Box sx={OrderHistoryTrackOrderStepsBarSX(currentStep)} />
			</Box>
		</Box>
	);
};
